<template>
    <div class="main-container">
        <div class="main-container-title-box">
            <div class="main-container-title-box-text">
                <span class="title-box-text">
                    Словарь запрещенных слов
                </span>
                <v-icon @mouseover="openInfo($event)" @mouseleave="showInfo = false"
                    color="var(--app-dark-blue-1)">mdi-information</v-icon>
            </div>
            <div style="width: 400px;">
                <v-text-field append-icon="mdi-magnify" hide-details label="Поиск" color="var(--app-dark-blue-1)"
                    single-line v-model="search"></v-text-field>
            </div>


        </div>
        <div class="d-flex justify-end">
            <!-- <v-btn  
           outlined color="var(--app-dark-blue-1)"  class="button-accept-outlined mr-10">
                Загрузить таблицу
            </v-btn> -->
            <v-btn @click="openDialog" class="button-accept mr-6">

                + Добавить слово
            </v-btn>
        </div>

        <v-menu v-model="showInfo" :position-x="x" :position-y="y" absolute offset-y>
            <v-card min-width="300px" min-height="100px">
                <div class="menu-container">
                    <div class="menu-container-title">
                        «Словарь запрещенных слов»
                    </div>
                    <div class="menu-container-text">
                        Слова из данного списка, будут автоматически блокировать сообщения, в которых они присутствуют
                    </div>

                </div>

            </v-card>
        </v-menu>

        <div class="container-table-box">
            <v-data-table :headers="tableHeaders" :items="items" fixed-header item-key="id" :search="search"
                :disable-pagination="true" :hide-default-footer="true" class="elevation-0 rounded-0 container-table">
                <template v-slot:item.actions="{ item }">
                    <v-icon @click="openDialog(item)">mdi-pencil-outline</v-icon>
                </template>

            </v-data-table>

        </div>

        <v-dialog width="570px" height="auto" persistent v-model="dialog">
            <v-card width="570px" height="auto" class="rounded-0">
                <v-form ref="formFirst">
                    <v-card-title class="dialog-title">
                        <span v-if="selectedItem.id" class="title">Редактировать слово</span>
                        <span v-else class="title">Добавить слово</span>
                        <v-icon @click="closeDialog">mdi-close</v-icon>
                    </v-card-title>
                    <v-card-text class="dialog-description">

                        <v-text-field class="mt-2" outlined :rules="rules" v-model="selectedItem.text"
                            label="Ввести"></v-text-field>

                    </v-card-text>
                    <v-card-actions class="dialog-buttons">
                        <v-btn style="width: 120px !important" @click="saveWord" class="button-accept">
                            Сохранить
                        </v-btn>
                        <v-btn v-if="selectedItem.id" @click="deleteWord" outlined style="width: 120px !important"
                            color="var(--app-red-1)" class="button-accept-outlined">
                            Удалить
                        </v-btn>
                    </v-card-actions>


                </v-form>
            </v-card>
        </v-dialog>


    </div>
</template>
<script>

export default {

    data: () => ({
        showInfo: false,
        x: null,
        y: null,
        search: '',
        dialog: false,
        selectedItem: {},
        items: [],
        rules: [value => !!value || 'Обязательно к заполнению'],
        tableHeaders: [
            { text: 'Навзание', sortable: false, value: 'text' },
            { text: '', sortable: false, align: 'right', value: 'actions' },

        ]

    }),
    methods: {

        openDialog(item) {
            if (item) {
                this.selectedItem = Object.assign({}, item)
                this.dialog = true
            }
            else {
                this.dialog = true
            }

        },
        closeDialog() {
            this.dialog = false
            setTimeout(() => {
                this.selectedItem = {}
                this.$refs.formFirst.resetValidation()
            }, 100)


        },
        saveWord() {
            if (this.$refs.formFirst.validate()) {
                if (this.selectedItem.id) {
                    this.$axios.put(this.$store.getters.apiAdminPanelV2 + '/club/chat/banWord', {
                        text: this.selectedItem.text,
                        wordId: this.selectedItem.id
                    }, {
                        headers: {
                            'authorization': this.$store.getters.adminPanelHeaderAuth
                        }
                    })
                        .then(() => {
                            this.closeDialog()
                            this.getItems()

                        })
                        .catch(err => {
                            this.$store.commit('errorSet', true)
                            this.$store.commit('errorTextSet', err)
                        })
                }
                else {
                    this.$axios.post(this.$store.getters.apiAdminPanelV2 + '/club/chat/banWord', {
                        text: this.selectedItem.text
                    }, {
                        headers: {
                            'authorization': this.$store.getters.adminPanelHeaderAuth
                        }
                    })
                        .then(() => {
                            this.closeDialog()
                            this.getItems()

                        })
                        .catch(err => {
                            this.$store.commit('errorSet', true)
                            this.$store.commit('errorTextSet', err)
                        })
                }

            }

        },
        deleteWord() {
            this.$axios.delete(this.$store.getters.apiAdminPanelV2 + '/club/chat/banWord', {
                headers: {
                    'authorization': this.$store.getters.adminPanelHeaderAuth
                },
                params: {
                    wordId: this.selectedItem.id
                }
            })
                .then(() => {
                    this.closeDialog()
                    this.getItems()
                })
                .catch(err => {
                    this.$store.commit('errorSet', true)
                    this.$store.commit('errorTextSet', err)
                })
        },
        openInfo(e) {
            e.preventDefault()
            this.x = e.clientX + 10
            this.y = e.clientY + 10
            this.showInfo = true
        },
        getItems() {
            this.$axios.get(this.$store.getters.apiAdminPanelV2 + '/club/chat/banWord/list', {
                headers: {
                    'authorization': this.$store.getters.adminPanelHeaderAuth
                }
            })
                .then(res => {
                    this.items = res.data
                })
                .catch(err => {
                    this.$store.commit('errorSet', true)
                    this.$store.commit('errorTextSet', err)
                })
        },

    },
    created() {
        this.getItems()
    },
}
</script>
<style lang="scss" scoped>
.container-table-box {
    height: calc(100vh - 240px) !important;
    overflow: auto;

    .container-table {
        height: calc(100vh - 240px) !important;
        min-height: calc(100vh - 240px) !important;
        max-height: calc(100vh - 240px) !important;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

    }
}
</style>